import EnquiryForm1 from "../enquiry/components/EnquiryForm1";
import EnquiryForm2 from "../enquiry/components/EnquiryForm2";
import EnquiryDemoForm1 from "../enquiry/components/EnquiryDemoForm1";
import EnquiryDemoForm2 from "../enquiry/components/EnquiryDemoForm2";
import StudentAdmissionFrom1 from "../student/components/StudentAdmissionFrom1";
import StudentDemoForm1 from "../student/components/StudentDemoForm1";
import StudentDemoForm2 from "../student/components/StudentDemoForm2";
import StudentAdmissionFrom2 from "../student/components/StudentAdmissionFrom2";
import StudentAdmissionFrom3 from "../student/components/StudentAdmissionFrom3";

export const formRegistry = {
  enquiry_form_1: EnquiryForm1,
  enquiry_form_2: EnquiryForm2,
  enquiry_demo_form_1: EnquiryDemoForm1,
  enquiry_demo_form_2: EnquiryDemoForm2,
  admission_form_1: StudentAdmissionFrom1,
  admission_form_2: StudentAdmissionFrom2,
  admission_form_3: StudentAdmissionFrom3,
  student_demo_form_1: StudentDemoForm1,
  student_demo_form_2: StudentDemoForm2,
};

export const feeTypes = [
  "Registration Fee",
  "Form Fee",
  "Tuition Fee",
  "Semester Fee",
  "Examination Fee",
  "Computer Fee",
  "Sports Fee",
  "Stationery Fee",
  "Late Fee",
  "Development Fee",
  "Id Card Fee",
  "Books Fee",
  "Uniform Fee",
  "Kit Fee",
  "Caution Money",
  "Other Charges",
  // "Institute Library Fee",
  // "Institute Transport Fee",
  // "Institute Hostel Fee",
];

export const managements = [
  {
    title: "Enquiry",
    icon: "ri-question-mark",
    tabs: [
      {
        key: "enquiry_fields",
        label: "Fields",
      },
      {
        key: "enquiry_form",
        label: "Enquiry Form",
      },
      {
        key: "enquiry_demo_form",
        label: "Enquiry Demo Form",
      },
    ],
  },
  {
    title: "Student",
    icon: "ri-user-line",
    tabs: [
      {
        key: "admission_fields",
        label: "Admission Fields",
      },
      {
        key: "admission_form",
        label: "Admission Form",
      },
      {
        key: "student_demo_form",
        label: "Student Demo Form",
      },
    ],
  },
  {
    title: "RTE",
    icon: "ri-graduation-cap-line",
    tabs: [
      {
        key: "rte_workflow",
        label: "RTE Workflow",
      },
    ],
  },
  {
    title: "Attendance",
    icon: "ri-calendar-check-line",
    tabs: [
      {
        key: "attendance_workflow",
        label: "Attendance Workflow",
      },
    ],
  },
  {
    title: "Fee Due-Paid Date",
    icon: "ri-calendar-check-line",
    tabs: [
      {
        key: "fee_due_paid_date_workflow",
        label: "Fee Due-Paid Date Workflow",
      },
    ],
  },
  {
    title: "Mobile Application",
    icon: "ri-smartphone-line",
    tabs: [
      {
        key: "staff_app_config_workflow",
        label: "Staff App Config",
      },
      {
        key: "student_app_config_workflow",
        label: "Student App Config",
      },
      {
        key: "student_fee_show_in_app_workflow",
        label: "App Fees Config",
      },
      {
        key: "student_profile_in_app_fields",
        label: "Student Profile Fields",
      },
    ],
  },

  {
    title: "Input Formatting",
    icon: "ri-font-size",
    tabs: [
      {
        key: "input_case_workflow",
        label: "Formatting Type",
      },
    ],
  },
];

export const defaultConfigData = [
  {
    title: "Enquiry",
    enquiry_fields: [
      {
        field: "secondary_mobile",
        show: 1,
        required: 0,
      },
      {
        field: "father_name",
        show: 1,
        required: 0,
      },
      {
        field: "email",
        show: 1,
        required: 0,
      },
      {
        field: "category",
        show: 1,
        required: 0,
      },
      {
        field: "gender",
        show: 1,
        required: 0,
      },
      {
        field: "hostel_status",
        show: 1,
        required: 0,
      },
      {
        field: "medium",
        show: 1,
        required: 0,
      },
      {
        field: "last_eduction",
        show: 1,
        required: 0,
      },
      {
        field: "last_institute_name",
        show: 1,
        required: 0,
      },
      {
        field: "village",
        show: 1,
        required: 0,
      },
      {
        field: "state",
        show: 1,
        required: 0,
      },
      {
        field: "district",
        show: 1,
        required: 0,
      },
      {
        field: "pincode",
        show: 1,
        required: 0,
      },
      {
        field: "reference_detail",
        show: 1,
        required: 0,
      },
      {
        field: "source",
        show: 1,
        required: 0,
      },
      {
        field: "note",
        show: 1,
        required: 0,
      },
      {
        field: "enquiry_date",
        show: 1,
        required: 0,
      },
      {
        field: "followup_date",
        show: 1,
        required: 0,
      },
      {
        field: "next_followup_date",
        show: 1,
        required: 0,
      },
      {
        field: "counselor_id",
        show: 1,
        required: 0,
      },
    ],
    enquiry_form: [
      {
        name: "enquiry_form_1",
        label: "Enquiry Form 1",
      },
      {
        name: "enquiry_form_2",
        label: "Enquiry Form 2",
      },
    ],

    enquiry_demo_form: [
      {
        name: "enquiry_demo_form_1",
        label: "Demo Form 1",
      },
      {
        name: "enquiry_demo_form_2",
        label: "Demo Form 2",
      },
    ],
  },
  {
    title: "Student",
    admission_fields: [
      {
        field: "secondary_mobile",
        show: 1,
        required: 0,
      },
      {
        field: "father_name",
        show: 1,
        required: 0,
      },
      {
        field: "mother_name",
        show: 1,
        required: 0,
      },
      {
        field: "father_occupation",
        show: 1,
        required: 0,
      },
      {
        field: "email",
        show: 1,
        required: 0,
      },
      {
        field: "category",
        show: 1,
        required: 0,
      },
      {
        field: "gender",
        show: 1,
        required: 0,
      },
      {
        field: "aadhar",
        show: 1,
        required: 0,
      },
      {
        field: "profile_picture",
        show: 1,
        required: 0,
      },
      {
        field: "dob",
        show: 1,
        required: 0,
      },
      {
        field: "hostel_status",
        show: 1,
        required: 0,
      },
      {
        field: "medium",
        show: 1,
        required: 0,
      },
      {
        field: "nic_id",
        show: 1,
        required: 0,
      },
      {
        field: "apaar_id",
        show: 1,
        required: 0,
      },
      {
        field: "student_type",
        show: 1,
        required: 0,
      },
      {
        field: "rte_status",
        show: 1,
        required: 0,
      },
      {
        field: "admission_date",
        show: 1,
        required: 1,
      },
      {
        field: "counselor_id",
        show: 1,
        required: 0,
      },
      {
        field: "referred_by",
        show: 1,
        required: 0,
      },
      {
        field: "village",
        show: 1,
        required: 0,
      },
      {
        field: "state",
        show: 1,
        required: 0,
      },
      {
        field: "district",
        show: 1,
        required: 0,
      },
      {
        field: "zipcode",
        show: 1,
        required: 0,
      },
      {
        field: "note",
        show: 1,
        required: 0,
      },

      {
        field: "father_mobile",
        show: 1,
        required: 0,
      },
      {
        field: "father_aadhar",
        show: 1,
        required: 0,
      },
      {
        field: "mother_mobile",
        show: 1,
        required: 0,
      },
      {
        field: "mother_aadhar",
        show: 1,
        required: 0,
      },
      {
        field: "caste_name",
        show: 1,
        required: 0,
      },
      {
        field: "religion",
        show: 1,
        required: 0,
      },
      {
        field: "pen_no",
        show: 1,
        required: 0,
      },
      {
        field: "jan_aadhar",
        show: 1,
        required: 0,
      },
      {
        field: "admission_class",
        show: 1,
        required: 0,
      },
    ],
    admission_form: [
      {
        name: "admission_form_1",
        label: "Admission Form 1",
      },
      {
        name: "admission_form_2",
        label: "Admission Form 2",
      },
      {
        name: "admission_form_3",
        label: "Admission Form 3",
      },
    ],

    student_demo_form: [
      {
        name: "student_demo_form_1",
        label: "Demo Form 1",
      },
      {
        name: "student_demo_form_2",
        label: "Demo Form 2",
      },
    ],
  },
  {
    title: "RTE",
    rte_workflow: feeTypes?.map((fee) => ({
      key: fee?.toLowerCase()?.replace(/\s+/g, "_"),
      label: `${fee} Free`,
      value: 0,
    })),
  },
  {
    title: "Attendance",
    attendance_workflow: [
      {
        key: "has_biometric_machine",
        label: "Biometric Machine Available",
        value: 0,
      },
      {
        show_condition: {
          key: "has_biometric_machine",
          value: 1,
        },
        key: "student_realtime_punch_msg",
        label: "Send Punch Alert to Parents",
        value: 0,
      },
      {
        key: "auto_mark_absent",
        label: "Auto Mark Absent",
        value: 0,
      },
      {
        key: "auto_send_absent_msg",
        label: "Auto Send Absent SMS",
        value: 0,
      },
      {
        show_condition: {
          key: "has_biometric_machine",
          value: 0,
        },
        key: "auto_send_present_msg",
        label: "Auto Send Present SMS",
        value: 0,
      },
      {
        show_condition: {
          key: "has_biometric_machine",
          value: 0,
        },
        key: "attendance_alert_send_staff",
        label: "Attendance Reminder Send Staff",
        value: 0,
      },
      {
        show_condition: {
          key: "attendance_alert_send_staff",
          value: 1,
        },
        input_type: "time",
        key: "attendance_alert_time",
        label: "Attendance Reminder Send Staff Time",
        value: "10:00",
      },
    ],
  },
  {
    title: "Fee Due-Paid Date",
    fee_due_paid_date_workflow: [
      {
        key: "has_fix_fee_due_paid_date",
        label: "Fee Due-Paid Date Available",
        value: 0,
      },

      // Date 1
      {
        show_condition: {
          key: "has_fix_fee_due_paid_date",
          value: 1,
        },
        input_type: "number",
        key: "fix_fee_due_paid_date_1",
        label: "Fix Fee Due Paid Date 1",
        value: null,
      },
      {
        show_condition: {
          key: "fix_fee_due_paid_date_1",
          operator: "not_null",
        },
        input_type: "number",
        key: "fix_fee_due_paid_date_1_from",
        label: "Day 1 Range From",
        value: null,
      },
      {
        show_condition: {
          key: "fix_fee_due_paid_date_1",
          operator: "not_null",
        },
        input_type: "number",
        key: "fix_fee_due_paid_date_1_to",
        label: "Day 1 Range To",
        value: null,
      },

      // Date 2
      {
        show_condition: {
          key: "has_fix_fee_due_paid_date",
          value: 1,
        },
        input_type: "number",
        key: "fix_fee_due_paid_date_2",
        label: "Fix Fee Due Paid Date 2",
        value: null,
      },
      {
        show_condition: {
          key: "fix_fee_due_paid_date_2",
          operator: "not_null",
        },
        input_type: "number",
        key: "fix_fee_due_paid_date_2_from",
        label: "Day 2 Range From",
        value: null,
      },
      {
        show_condition: {
          key: "fix_fee_due_paid_date_2",
          operator: "not_null",
        },
        input_type: "number",
        key: "fix_fee_due_paid_date_2_to",
        label: "Day 2 Range To",
        value: null,
      },

      // Date 3
      {
        show_condition: {
          key: "has_fix_fee_due_paid_date",
          value: 1,
        },
        input_type: "number",
        key: "fix_fee_due_paid_date_3",
        label: "Fix Fee Due Paid Date 3",
        value: null,
      },
      {
        show_condition: {
          key: "fix_fee_due_paid_date_3",
          operator: "not_null",
        },
        input_type: "number",
        key: "fix_fee_due_paid_date_3_from",
        label: "Day 3 Range From",
        value: null,
      },
      {
        show_condition: {
          key: "fix_fee_due_paid_date_3",
          operator: "not_null",
        },
        input_type: "number",
        key: "fix_fee_due_paid_date_3_to",
        label: "Day 3 Range To",
        value: null,
      },
    ],
  },
  {
    title: "Mobile Application",
    staff_app_config_workflow: [
      {
        key: "allow_staff_reply_feedback",
        label: "Allow Staff to Reply Feedback",
        value: 0,
      },
      {
        key: "allow_staff_to_capture_student_profile_picture",
        label: "Allow Staff to Capture Student Profile Picture",
        value: 0,
      },
    ],

    student_app_config_workflow: [
      {
        key: "allow_student_edit_profile",
        label: "Allow Student Edit Profile",
        value: 1,
      },
      {
        key: "allow_custom_push_notification_voice",
        label: "Allow Custom Push Notification Voice",
        value: 0,
        button: {
          label: "Go to message configuration",
          route: "/message/list",
        },
      },
      {
        key: "allow_student_view_timetable",
        label: "Allow Student to View Timetable",
        value: 1,
      },
    ],

    student_fee_show_in_app_workflow: [
      {
        key: "show_total_fee",
        label: "Show Total Fee",
        value: 0,
      },
      {
        key: "show_paid_fee",
        label: "Show Paid Fee",
        value: 0,
      },
      {
        key: "show_due_fee",
        label: "Show Due Fee",
        value: 0,
      },
      {
        key: "show_fee_receipt",
        label: "Show Fee Receipt",
        value: 0,
      },
      {
        key: "allow_fee_payment",
        label: "Allow Online Fee Payment",
        value: 0,
      },
      {
        key: "allow_fee_receipt_download",
        label: "Allow Fee Receipt Download",
        value: 0,
      },
      {
        key: "allow_fee_receipt_share",
        label: "Allow Fee Receipt Share",
        value: 0,
      },
    ],

    student_profile_in_app_fields: [
      {
        field: "name",
        show: 1,
        required: 1,
      },
      {
        field: "phone",
        show: 1,
        required: 1,
      },
      {
        field: "secondary_mobile",
        show: 1,
        required: 0,
      },
      {
        field: "father_name",
        show: 1,
        required: 1,
      },
      {
        field: "mother_name",
        show: 1,
        required: 0,
      },
      {
        field: "father_occupation",
        show: 1,
        required: 0,
      },
      {
        field: "email",
        show: 1,
        required: 0,
      },
      {
        field: "category",
        show: 1,
        required: 0,
      },
      {
        field: "aadhar",
        show: 1,
        required: 0,
      },
      {
        field: "profile_picture",
        show: 1,
        required: 1,
      },
      {
        field: "gender",
        show: 1,
        required: 1,
      },
      {
        field: "dob",
        show: 1,
        required: 1,
      },
      {
        field: "state",
        show: 1,
        required: 0,
      },
      {
        field: "district",
        show: 1,
        required: 0,
      },
      {
        field: "zipcode",
        show: 1,
        required: 0,
      },
      {
        field: "country",
        show: 1,
        required: 0,
      },
      {
        field: "village",
        show: 1,
        required: 0,
      },
      {
        field: "tehsile",
        show: 1,
        required: 0,
      },
      {
        field: "education",
        show: 1,
        required: 0,
      },
      {
        field: "school",
        show: 1,
        required: 0,
      },
      {
        field: "admission_date",
        show: 1,
        required: 1,
      },
      {
        field: "referred_by",
        show: 1,
        required: 0,
      },
      {
        field: "remark",
        show: 1,
        required: 0,
      },
      {
        field: "nic_id",
        show: 1,
        required: 0,
      },
      {
        field: "apaar_id",
        show: 1,
        required: 0,
      },
      {
        field: "student_type",
        show: 1,
        required: 0,
      },
      {
        field: "hostel_status",
        show: 1,
        required: 0,
      },
      {
        field: "bus_status",
        show: 1,
        required: 0,
      },
      {
        field: "medium",
        show: 1,
        required: 0,
      },
      {
        field: "father_mobile",
        show: 1,
        required: 0,
      },
      {
        field: "father_aadhar",
        show: 1,
        required: 0,
      },
      {
        field: "mother_mobile",
        show: 1,
        required: 0,
      },
      {
        field: "mother_aadhar",
        show: 1,
        required: 0,
      },
      {
        field: "caste_name",
        show: 1,
        required: 0,
      },
      {
        field: "religion",
        show: 1,
        required: 0,
      },
      {
        field: "pen_no",
        show: 1,
        required: 0,
      },
      {
        field: "jan_aadhar",
        show: 1,
        required: 0,
      },
      {
        field: "admission_class",
        show: 1,
        required: 0,
      },
    ],
  },

  {
    title: "Input Formatting",
    input_case_workflow: [
      {
        input_type: "select",
        key: "input_case_type",
        label: "Formatting Type",
        value: "uppercase",
        options: [
          { label: "UPPERCASE", value: "uppercase" },
          { label: "lowercase", value: "lowercase" },
          { label: "Capitalize", value: "capitalize" },
          { label: "None", value: "none" },
        ],
      },
    ],
  },
];
